import { OperationVariables, ApolloQueryResult } from '@apollo/client'
import { Fade, IconButton, Typography } from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'

import { getTranslate } from '../../localization'
import { CancelPolicy } from '../../types/cancelAndModifyPolicies'
import PolicyRow from './PolicyRow'
import PolicyRowSkeleton from './PolicyRow.skeleton'
import useStyles from './styles/PoliciesTable.styles'

interface PoliciesTableProps {
  data: CancelPolicy[]
  refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<
    ApolloQueryResult<{
      cancelPolicies: CancelPolicy[]
    }>
  >
  loadingForCancelPolicy: boolean
  providerCode: string
}

export const PoliciesTable: React.FC<PoliciesTableProps> = ({
  refetch,
  data,
  loadingForCancelPolicy,
  providerCode
}) => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <div className={classes.tableHead}>
        <div>
          <Typography variant="body1">{getTranslate('Name')}</Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate('Description')}</Typography>
        </div>
        <div className={classes.refreshButtonContainer}>
          <IconButton
            onClick={() => {
              refetch()
            }}>
            <RefreshIcon fontSize="small" />
          </IconButton>
        </div>
      </div>
      {loadingForCancelPolicy
        ? Array(5)
            .fill('')
            .map((item, index) => (
              <PolicyRowSkeleton
                key={`accommodation-skeleton${item}${index.toString()}`}
              />
            ))
        : data.map((singlePolicy) => (
            <Fade in timeout={600} key={singlePolicy.basicDetails.id}>
              <div>
                <PolicyRow data={singlePolicy} providerCode={providerCode} />
              </div>
            </Fade>
          ))}
    </div>
  )
}
